<template>
  <swiper-container
    ref="swiperEl"
    init="false"
    class="group !overflow-visible rounded-lg pb-10"
  >
    <swiper-slide v-for="(slide, i) in slides" :key="i">
      <SolutionsCarouselSlideMobile
        v-bind="slide"
      ></SolutionsCarouselSlideMobile>
    </swiper-slide>

    <div slot="container-end" class="swiper-scrollbar"></div>
  </swiper-container>
</template>

<script setup lang="ts">
import SolutionsCarouselSlideMobile from '~/components/sections/sliderSection/SolutionsCarouselSlideMobile.vue';
import { useSwiperElement } from '~/composables';

interface Props {
  slides?: any[];
}
interface Emits {
  (e: 'slide-change', data: number): void;
  (e: 'init', data: any): void;
}

withDefaults(defineProps<Props>(), {
  slides: () => [],
});

const emit = defineEmits<Emits>();

const swiperOptions = {
  observer: true,
  slidesPerView: 1,
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  on: {
    init: (swiper: any) => emit('init', swiper),
    activeIndexChange: (swiper: any) =>
      emit('slide-change', swiper.activeIndex),
  },
};

const swiperEl = useSwiperElement(swiperOptions);
</script>
